import { IPackageListingAppState } from "..";
import PackageApi from "../../common/package-api";
import { processPackageRequest, processPackageRequestError, receivePerformancePricing, receivePackagePricing } from "./package-listing.actions";
import { IPerformancePricing } from "../../custom/classes/production";
import { filterMap } from "../../helpers/map-helpers";

export function processPackage() {
    return (dispatch, getState: () => IPackageListingAppState) => {
        const state = getState();

        dispatch(processPackageRequest());
        var priceTypes = [];

        Array.from(state.packageListing.priceTypeQuantity.keys()).forEach(pt => {
            var quantity = state.packageListing.priceTypeQuantity.get(pt);
            var i;
            for (i = 0; i < quantity; i++) {
                priceTypes.push(pt);
            }

        });

        if (state.packageListingSettings.isFixed) {

            const superPackagesInCart = state.packageListing.subPackagesInCart;
            var regularFixedPackages = state.packageListing.cartItems;

            if (superPackagesInCart.size > 0) {
                // has super packages in cart

                regularFixedPackages = filterMap(state.packageListing.cartItems,
                    packageId => Array.from(superPackagesInCart.keys()).indexOf(packageId) < 0)

                superPackagesInCart.forEach((subPackageIds, packageId) => {
                    let subPackageZones = {};

                    subPackageIds.forEach(subPackageId => {
                        subPackageZones[subPackageId] = state.packageListing.cartItems.get(subPackageId);
                    })

                    PackageApi.processSuperPackage(packageId,
                        subPackageZones,
                        priceTypes,
                        state.packageListing.orderNotes,
                        state.packageListingSettings.configId,
                        state.packageListing.accessibleSeatingRequested
                    ).then(apiResult => {
                        if (apiResult.success && apiResult.redirectUrl != null) {
                            window.location = apiResult.redirectUrl;
                        } else {
                            dispatch(processPackageRequestError(apiResult.errorMessages));
                        }
                    }).catch(error => {
                        //dispatch(errorPromoCodeApply(error));
                    });
                })
            } else {
                regularFixedPackages.forEach((zoneId, packageId) => {

                    PackageApi.processFixedPackage(packageId,
                        zoneId,
                        priceTypes,
                        state.packageListing.orderNotes,
                        state.packageListingSettings.configId,
                        state.packageListing.seatingPreferences,
                        state.packageListing.accessibleSeatingRequested
                    ).then(apiResult => {
                        if (apiResult.success && apiResult.redirectUrl != null) {
                            window.location = apiResult.redirectUrl;
                        } else {
                            dispatch(processPackageRequestError(apiResult.errorMessages));
                        }
                    }).catch(error => {
                        //dispatch(errorPromoCodeApply(error));
                    });
                });
            }
        } else {
            let performanceZones = {};

            for (let [key, value] of state.packageListing.cartItems) {
                performanceZones[key] = value;
            }

            const packageId = state.packageListing.packageDetail.id;
            const performanceIds = Object.keys(performanceZones).join(',');

            PackageApi.flexPackageSessionVariable(packageId, performanceIds);

            return PackageApi.processFlexPackage(state.packageListing.packageDetail.id, performanceZones,
                priceTypes, state.packageListing.packageDetail.useUnseatedReservation,
                state.packageListing.orderNotes,
                state.packageListingSettings.configId,
                state.packageListing.accessibleSeatingRequested,
                state.packageListing.performanceSeatStatuses
            ).then(apiResult => {
                if (apiResult.success && apiResult.redirectUrl != null) {
                    Object.keys(localStorage)
                        .filter(key => key.startsWith('SSv2_SeatRequest'))
                        .forEach(key => localStorage.removeItem(key));
                    window.location = apiResult.redirectUrl;
                } else {
                    dispatch(processPackageRequestError(apiResult.errorMessages));
                }
            }).catch(error => {
                //dispatch(errorPromoCodeApply(error));
            });
        }

    }
}

export function getPerformancePricing(performanceId: number, packageId: number) {
    return (dispatch, getState: () => IPackageListingAppState) => {

        //dispatch(processPackageRequest());

        return PackageApi.getPerformancePricing(performanceId, packageId).then(apiResult => {

            dispatch(receivePerformancePricing(apiResult));
        }).catch(error => {
            //dispatch(errorPromoCodeApply(error));
        });
    }
}

export function getPackagePricing(packageId: number) {
    return (dispatch, getState: () => IPackageListingAppState) => {

        return PackageApi.getPackagePricing(packageId).then(apiResult => {

            dispatch(receivePackagePricing(apiResult));
        }).catch(error => {
        });
    }
}